import serviceGomiyashiki from '@/assets/images/service-gomiyashiki.webp';
import serviceIhin from '@/assets/images/service-ihin.webp';
import serviceFuyo from '@/assets/images/service-fuyo.webp';
import serviceTokushu from '@/assets/images/service-tokushu.webp';
import serviceKaitai from '@/assets/images/service-kaitai.jpg';
import serviceHikkoshi from '@/assets/images/service-hikkoshi.webp';

const mainServices = [
  {
    icon: 'ri-home-smile-line',
    title: 'ゴミ屋敷・汚部屋のお片付け',
    description: '足の踏み場もない状態から、スッキリ快適な空間へ。プライバシーに配慮し、秘密厳守で作業を行います。',
    features: ['分別・梱包', '搬出・処分', '簡易清掃'],
    image: serviceGomiyashiki,
    href: 'https://www.kataduke-kaitori.com/gomiyashiki-kataduke/',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '遺品整理・生前整理',
    description: '故人様の想い出の品を、ご遺族様に代わって丁寧に整理・仕分けいたします。権利書や貴重品の探索もお任せください。',
    features: ['貴重品探索', '供養・お焚き上げ', '形見分け配送'],
    image: serviceIhin,
    href: 'https://www.kataduke-kaitori.com/relic/',
  },
  {
    icon: 'ri-recycle-line',
    title: '不用品回収',
    description: '少量の不用品から家一軒丸ごとまで対応。家具、家電、衣類など、あらゆるものを回収・処分いたします。',
    features: ['家具・家電', 'リサイクル対応', '即日回収可能'],
    image: serviceFuyo,
    href: 'https://www.kataduke-kaitori.com/clearance/',
  },
  {
    icon: 'ri-drop-line',
    title: '特殊清掃',
    description: '孤独死や事故現場など、通常の清掃では対処できない現場の消臭・消毒・原状回復を行います。',
    features: ['消臭・脱臭', '害虫駆除', '特殊コーティング'],
    image: serviceTokushu,
    href: 'https://www.kataduke-kaitori.com/clean/',
  },
  {
    icon: 'ri-building-2-line',
    title: '家屋解体',
    description: '不要になった建物の解体・撤去を行います。廃材の適切な処分から近隣への配慮まで、安全・丁寧に対応いたします。',
    features: ['建物解体', '廃材処分', '整地作業'],
    image: serviceKaitai,
    href: 'https://www.kataduke-kaitori.com/demolition/',
  },
  {
    icon: 'ri-truck-line',
    title: 'お引越しに伴う不用品回収',
    description: '引越しに伴う不用品の処分や、退去時の清掃をサポート。急な引越しでもスピーディーに対応します。',
    features: ['退去清掃', '荷造り・荷解き', '家具移動'],
    image: serviceHikkoshi,
    href: 'https://www.kataduke-kaitori.com/moving/',
  },
];

const subServices = [
  { icon: 'ri-tv-line',           title: '家電の回収・処分',         href: 'https://www.kataduke-kaitori.com/home-appliances/' },
  { icon: 'ri-sofa-line',         title: '粗大ゴミの回収・処分',     href: 'https://www.kataduke-kaitori.com/sodaigomi-kaishu/' },
  { icon: 'ri-home-8-line',       title: '大量の不用品・お家まるごと', href: 'https://www.kataduke-kaitori.com/clearance/' },
  { icon: 'ri-building-line',     title: 'オフィスの不用品回収',     href: 'https://www.kataduke-kaitori.com/office/' },
  { icon: 'ri-money-dollar-circle-line', title: '不用品の高価買取',   href: 'https://www.kataduke-kaitori.com/purchase/' },
  { icon: 'ri-shield-check-line', title: '除菌コーティング',         href: 'https://www.kataduke-kaitori.com/disinfection/' },
  { icon: 'ri-gift-line',         title: '雑貨等の寄付「リボーン」', href: 'https://www.kataduke-kaitori.com/reborn/' },
  { icon: 'ri-smartphone-line',   title: '見守りアプリ「もし活」',   href: 'https://www.good-service.co.jp/moshikatsu/' },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-tools-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">サービス一覧</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            お部屋の悩みを <strong className="text-primary">すべて解決</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            どんな状態のお部屋でもお任せください。プロの技術と経験で、お客様のご要望に合わせた最適なプランをご提案します。
          </p>
        </div>

        {/* Main Services Grid（画像付き） */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {mainServices.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl border border-gray-200 hover:border-primary hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
            >
              {/* 画像エリア */}
              <div className="relative h-48 w-full flex-shrink-0 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute bottom-3 left-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary to-pink-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* テキストエリア */}
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-5 leading-relaxed text-sm flex-1">{service.description}</p>
                <ul className="space-y-2 mb-5">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-checkbox-circle-fill text-primary"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <a
                  href={service.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-primary font-semibold text-sm hover:gap-3 transition-all cursor-pointer"
                >
                  詳しく見る
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Sub Services Grid（簡易・画像なし） */}
        <div className="mb-16">
          <h3 className="text-xl font-bold text-gray-700 mb-6 flex items-center gap-2">
            <span className="w-1 h-6 bg-primary rounded-full inline-block"></span>
            その他のサービス
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {subServices.map((s, index) => (
              <a
                key={index}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white border border-gray-200 rounded-xl p-5 hover:border-primary hover:shadow-md transition-all flex items-center gap-3 cursor-pointer"
              >
                <div className="w-10 h-10 bg-pink-50 group-hover:bg-primary rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                  <i className={`${s.icon} text-xl text-primary group-hover:text-white transition-colors`}></i>
                </div>
                <span className="text-sm font-semibold text-gray-800 group-hover:text-primary transition-colors leading-snug">{s.title}</span>
              </a>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-primary to-pink-600 rounded-2xl p-10 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">お急ぎの方もご安心ください</h3>
          <p className="text-xl mb-6 text-pink-50">最短即日で対応可能です。まずは無料でお見積りをご依頼ください。</p>
          <a
            href="tel:0120-952-005"
            className="inline-flex flex-col items-center gap-1 px-8 py-4 bg-white text-primary font-bold rounded-lg hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <i className="ri-phone-fill text-2xl"></i>
              <span className="text-3xl">0120-952-005</span>
            </div>
            <span className="text-sm font-normal text-gray-600">9:00-20:00 年中無休（年末年始・お盆除く）</span>
          </a>
        </div>
      </div>
    </section>
  );
}
